(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camera-block"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-camera-block-script')
    if (!window.cameraBlock && $url) {
      window.cameraBlock = $url.value

      var $script = document.createElement('script')
      $script.src = window.cameraBlock
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-slideshow"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-collapsible-slideshow-script')
    if (!window.collapsibleSlideshow && $url) {
      window.collapsibleSlideshow = $url.value

      var $script = document.createElement('script')
      $script.src = window.collapsibleSlideshow
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-contact-form-script')
    if (!window.contactFomr && $url) {
      window.contactFomr = $url.value

      var $script = document.createElement('script')
      $script.src = window.contactFomr
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exploded-video"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-exploded-video-script')
    if (!window.explodedVideo && $url) {
      window.explodedVideo = $url.value

      var $script = document.createElement('script')
      $script.src = window.explodedVideo
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sequences"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sequences-script')
    if (!window.imageSequence && $url) {
      window.imageSequence = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSequence
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-overlay"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-with-text-overlay-script')
    if (!window.imageWithTextOvarlay && $url) {
      window.imageWithTextOvarlay = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageWithTextOvarlay
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-number-list"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-new-number-list-script')
    if (!window.newNumberList && $url) {
      window.newNumberList = $url.value

      var $script = document.createElement('script')
      $script.src = window.newNumberList
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["number-list"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-numberlist-script')
    if (!window.numberlist && $url) {
      window.numberlist = $url.value

      var $script = document.createElement('script')
      $script.src = window.numberlist
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overview"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-overview-script')
    if (!window.customizeOverview && $url) {
      window.customizeOverview = $url.value

      var $script = document.createElement('script') 
      $script.src = window.customizeOverview
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-design"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-pdp-design-script')
    if (!window.pdpDesign && $url) {
      window.pdpDesign = $url.value

      var $script = document.createElement('script') 
      $script.src = window.pdpDesign
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-overview"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-pdp-overview-script')
    if (!window.pdpOverview && $url) {
      window.pdpOverview = $url.value

      var $script = document.createElement('script') 
      $script.src = window.pdpOverview
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phone-spec"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-specs-script')
    if (!window.specs && $url) {
      window.specs = $url.value
      var $script = document.createElement('script')
      $script.src = window.specs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-banner"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-banner-script')
    if (!window.productBanner && $url) {
      window.productBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.productBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-review-form-script')
    if (!window.reviewFomr && $url) {
      window.reviewFomr = $url.value

      var $script = document.createElement('script')
      $script.src = window.reviewFomr
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-slideshow-script')
    if (!window.slideshow && $url) {
      window.slideshow = $url.value

      var $script = document.createElement('script')
      $script.src = window.slideshow
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow3"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-slideshow3-script')
    if (!window.slideshow3 && $url) {
      window.slideshow3 = $url.value

      var $script = document.createElement('script') 
      $script.src = window.slideshow3
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-specs-script')
    if (!window.specs && $url) {
      window.specs = $url.value

      var $script = document.createElement('script')
      $script.src = window.specs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-banner"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-support-banner-script');
    if (!window.pdpOverview && $url) {
      window.pdpOverview = $url.value;

      var $script = document.createElement('script');
      $script.src = window.pdpOverview;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
